export const buildProvenance = { "commitHash": "7b37627d384037f9856062db8bcec6de99655e3a", "branchName": "refs/heads/release/2024.1", "buildDate": "2024-04-24T05:36:54.275Z", "version": "2024.1.12600" };
